import { render, staticRenderFns } from "./OrdersCampaigns.vue?vue&type=template&id=60c37bbc&scoped=true&"
import script from "./OrdersCampaigns.vue?vue&type=script&lang=js&"
export * from "./OrdersCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c37bbc",
  null
  
)

export default component.exports